import { DateTime } from 'luxon';

export type WorkingDayDefinition = { excludePublicHolidays: boolean, excludeWeekends: boolean };

// This class matches the same logic as the corresponding class on the server side
export class MaatWorkingDayCalculator {

  private getPublicHolidayTimestamps: () => Set<number>;

  constructor(getPublicHolidayDates: () => DateTime[]) {
    this.getPublicHolidayTimestamps = () => new Set((getPublicHolidayDates?.() ?? []).map(date => date.startOf('day').valueOf()));
  }

  addWorkingDaysFromHours(inputDate: DateTime, hoursToAdd: number, workingDayDefinition: WorkingDayDefinition): DateTime {

    // To allow for testing, we implement a different logic when -24 < hoursToAdd < 24
    if (hoursToAdd > -24 && hoursToAdd < 24) {
      return inputDate.plus({ hours: hoursToAdd });
    }
    else {
      const daysToAdd = Math.trunc(hoursToAdd / 24);
      return this.addWorkingDays(inputDate, daysToAdd, workingDayDefinition);
    }
  }

  addWorkingDays(inputDate: DateTime, daysToAdd: number, workingDayDefinition: WorkingDayDefinition): DateTime {

    if (daysToAdd === 0) {
      return inputDate;
    }

    let outputDate = inputDate.startOf('day');

    workingDayDefinition ??= { excludePublicHolidays: false, excludeWeekends: false };

    const { excludePublicHolidays, excludeWeekends } = workingDayDefinition;

    const timestampsToSkip = excludePublicHolidays ? this.getPublicHolidayTimestamps() : new Set<number>();
    const weekdaysToSkip = excludeWeekends ? new Set([6, 7]) : new Set<number>();

    if (timestampsToSkip.size === 0 && weekdaysToSkip.size === 0) {
      outputDate = outputDate.plus({ days: daysToAdd });
    }
    else {
      const direction = Math.sign(daysToAdd);
      let remainingDays = Math.abs(daysToAdd);

      while (remainingDays > 0) {
        outputDate = outputDate.plus({ days: direction });
        if (!timestampsToSkip.has(outputDate.valueOf()) && !weekdaysToSkip.has(outputDate.weekday)) {
          remainingDays--;
        }
      }
    }

    if (daysToAdd > 0) {
      outputDate = outputDate.endOf('day');
    }

    return outputDate;
  }
}
